import { Link } from "react-router-dom";
import { FadeUp } from "./_shared";
import HudCorners from "./_partials/HudCorners";

const FOUNDER_IMG = "/updates/cannes-interview-reel.jpg";

export default function FounderShort() {
  return (
    <section
      id="founder"
      data-testid="founder-short-section"
      className="py-24 md:py-32 bg-foreground text-background"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <FadeUp className="lg:col-span-4 order-first lg:order-none">
            <div className="relative max-w-[320px] mx-auto lg:mx-0">
              <div className="iw-scan-sweep relative aspect-[4/5] overflow-hidden border border-background/20">
                <img
                  src={FOUNDER_IMG}
                  alt="John Campetella at Cineum Cannes"
                  data-testid="founder-image"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a45]/60 to-transparent" />
                <HudCorners offset={10} size={12} />
              </div>
              <div className="mt-4">
                <div className="font-display text-lg font-bold text-background">John Campetella</div>
                <div className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-background/55 mt-1">
                  Founder · CEO · Author of the Unified Medical Model
                </div>
              </div>
            </div>
          </FadeUp>

          <div className="lg:col-span-8">
            <FadeUp>
              <div className="font-mono text-[0.65rem] uppercase tracking-[0.24em] text-background/55">
                <span className="text-accent">§</span> Why This Exists
              </div>
              <blockquote
                data-testid="founder-quote"
                className="mt-6 font-display text-xl md:text-2xl lg:text-[1.75rem] font-semibold leading-snug text-background"
              >
                "I built Integrated Wellness after watching both of my parents navigate a
                healthcare system where every condition was treated separately. I believed there
                had to be a better way to understand the whole person — the relationships between
                metabolism, sleep, hormones, cognition, inflammation, fitness and everything else
                that shapes health over time."
              </blockquote>
            </FadeUp>
            <FadeUp delay={0.1} className="mt-8">
              <Link
                to="/founder-story"
                data-testid="founder-story-link"
                className="inline-flex items-center gap-2 font-mono text-[0.68rem] uppercase tracking-[0.2em] font-semibold text-background border border-background/40 px-7 py-3.5 hover:bg-background hover:text-foreground transition-colors"
              >
                Read John's Story <span aria-hidden>→</span>
              </Link>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
